export default __webpack_public_path__ + "static/media/ly.d26de1e2.svg";